import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FiltroTabItem {
  valor: string;
  label: string;
  contador?: number;
  corBolinha?: string;
}

@Component({
  selector: 'app-filtros-tab',
  standalone: true,
  imports: [],
  templateUrl: './filtros-tab.component.html',
  styleUrl: './filtros-tab.component.css'
})
export class FiltrosTabComponent {
  @Input() abas: FiltroTabItem[] = [];
  @Input() abaAtiva = '';
  @Input() carregando = false;
  @Input() qtdSkeleton = 3;

  @Output() aoSelecionar = new EventEmitter<string>();

  get skeletonArray(): number[] {
    return Array.from({ length: this.qtdSkeleton });
  }

  selecionar(valor: string) {
    if (valor === this.abaAtiva) {
      return;
    }
    this.aoSelecionar.emit(valor);
  }
}
